import * as yup from 'yup';

export const SkillSchema = yup
  .object({
    id: yup.string().label('id').required(),
    name: yup.string().label('name').required(),
  })
  .required();
